import React, { useLayoutEffect } from "react"
import { Button } from "@/components"
import { AIChatIcon } from "@/pages/ai-chat/components/AIChatIcon"
import { useStyles } from "@/pages/ai-chat/components/AIChatToggle.styles"
import { useLocalStorage } from "@mantine/hooks"
import { useMatch } from "react-router-dom"

const { QuorumDataType } = DjangIO.app.models

interface Props {
    popdownIsOpen: boolean
}

export const AIChatToggle = (props: Props) => {
    const { classes, cx } = useStyles()
    // Routing
    const match = useMatch(":dataType/:profileId/*")
    const params = match?.params

    const [defaultOpenCopilotAnalyze, setDefaultOpenCopilotAnalyze] = useLocalStorage({
        key: "copilot-analyze-default-open",
        defaultValue: true,
        getInitialValueInEffect: false,
    })
    const [isOpen, setIsOpen] = useLocalStorage({ key: "ai-chat-is-open", defaultValue: false })
    const isOpened = isOpen && props.popdownIsOpen

    useLayoutEffect(() => {
        if (defaultOpenCopilotAnalyze) {
            if (([QuorumDataType.bill.key, QuorumDataType.event.key] as string[]).includes(params?.dataType)) {
                setIsOpen(true)
                setDefaultOpenCopilotAnalyze(false)
            }
        }
    }, [defaultOpenCopilotAnalyze, params?.dataType, setDefaultOpenCopilotAnalyze, setIsOpen])

    const handleClick = () => {
        setIsOpen(!isOpen)

        // @ts-expect-error
        document.activeElement.blur()
    }

    return (
        <Button
            variant="outline"
            className={cx(classes.button, {
                [classes.active]: isOpen,
                [classes.popdownIsOpen]: props.popdownIsOpen,
                [classes.isOpened]: isOpened,
            })}
            onClick={handleClick}
            aria-label="Toggle Copilot Analyze"
            data-plum-id="ai-chat-toggle"
        >
            <AIChatIcon popdownIsOpen={props.popdownIsOpen} isOpen={isOpen} />
        </Button>
    )
}
